import { render, staticRenderFns } from "./AppBarFrontPage.vue?vue&type=template&id=4921daa9&scoped=true"
import script from "./AppBarFrontPage.vue?vue&type=script&lang=js"
export * from "./AppBarFrontPage.vue?vue&type=script&lang=js"
import style0 from "./AppBarFrontPage.vue?vue&type=style&index=0&id=4921daa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4921daa9",
  null
  
)

export default component.exports